export enum SituationHydrologie6sem {
    Inconnu = 0,
    Stable = 1,
    EvenementHydroModere = 2,
    EvenementHydroImportant = 3,
    EvenementHydroExceptionnel = 4,
}
